export interface Meta {
  count?: number;
  limit: number;
  offset: number;
  search?: string;
  [index: string]: string | number | undefined;
}

export interface Option {
  value: number | string;
  label: string;
}

export interface DefaultLanguage {
  name: string;
  code: string;
}

export interface MessageValues {
  [key: string]: string | number;
}

export enum ResourceType {
  Image = "image",
  Video = "video",
}

export interface ContactType {
  type: string;
  url: string;
  title: string;
}
